module.exports = __webpack_public_path__ + "img/League_03.d986cdcd.png";